module.exports = __webpack_public_path__ + "img/Group-817.6965a446.png";